<template>
    <card-container>
      <v-container>
        <v-layout align-center justify-center row>
        <v-flex xs12>
          <v-form @submit.prevent="onSubmit" class="forgot-password-form">
            <v-layout row wrap>
              <v-flex xs12>
                <CardTitle>
                  Access My Account
                </CardTitle>
                <p>If you forgot your username/password,
                  or need to gain initial access to your account, enter your email address.</p>
              </v-flex>

              <v-flex xs12>
                <base-alert :hg-value="showError" hg-type="error">
                  {{errorText}}
                </base-alert>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                v-model="model.email"
                v-validate="inputValidations.email"
                :error-messages="errors.collect('email')"
                label="Email Address"
                autocomplete="email"
                name="email"
                class="email-field"
                single-line />
              </v-flex>

              <v-flex xs12>
                <BaseButton
                  :disabled="!submitIsEnabled"
                  :hg-label="submitLabel"
                  type="submit" />
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
      </v-container>
  </card-container>
</template>

<script>
import { Components, Constants, Mixins } from '@spectorasoftware/homegauge-vue';
import VeeValidate from 'vee-validate';
import Vue from 'vue';

import CardContainer from '@/components/CardContainer.vue';
import CardTitle from '@/components/CardTitle.vue';

const { BaseAlert, BaseButton } = Components;
const { InputValidations } = Constants;
const { FormValidationsMixin } = Mixins;

Vue.use(VeeValidate);

export default {
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    BaseButton,
    CardTitle,
    'base-alert': BaseAlert,
    'card-container': CardContainer,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      model: { email: this.email.trim() },
      errorText: '',
      loading: false,
      inputValidations: InputValidations,
      reCaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_KEY,
      recaptchaToken: '',
      showError: false,
    };
  },
  mixins: [FormValidationsMixin],
  mounted() {
    this.executeRecaptcha('forgot_password_load');
  },
  computed: {
    submitIsEnabled() {
      return !!(!this.loading
        && this.model.email
        && !this.formHasErrors);
    },
    submitLabel() {
      return this.loading
        ? 'Looking up your Account'
        : 'Submit';
    },
  },
  methods: {
    executeRecaptcha(action) {
      const { grecaptcha } = window;
      return new Promise(resolve => {
        grecaptcha.ready(() => {
          grecaptcha.execute(this.reCaptchaSiteKey, { action })
            .then(token => resolve(token));
        });
      });
    },
    onSubmit() {
      this.resetError();
      if (this.submitIsEnabled) {
        this.loading = true;
        this.$validator.validateAll()
          .then(res => {
            if (res) {
              this.submitData();
            }
          })
          .catch(err => {
            this.loading = false;
            this.setError(err);
          });
      }
    },
    resetError() {
      this.showError = false;
      this.errorText = '';
    },
    setError(err) {
      this.showError = true;
      this.errorText = (err && typeof err === 'string')
        ? err
        : 'There was an error processing your request, please try again.';
    },
    submitData() {
      return this.executeRecaptcha('forgot_password_submit')
        .then(token => this.$store.dispatch('Person/passwordReset', {
          email: this.model.email,
          recaptchaToken: token,
        }))
        .then(() => {
          this.loading = false;
          this.$router.push('/forgot-password/confirmation');
        })
        .catch(err => {
          this.loading = false;
          this.setError(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/vars/typography';

.forgot-password-form {
  font-family: $typography-font-primary;
}

#recaptcha {
  padding: 15px 0;
}
</style>
